import indefinite from "indefinite"
import pluralize from "pluralize"

// The things an organization may rename.  Mirrors the keys registered on the
// CustomName model, which is what the backend validates a key against.
export const DEPARTMENT_KEY = "department"
export const FACILITY_KEY = "facility"

export const KEYS = [
  DEPARTMENT_KEY,
  FACILITY_KEY,
]

// The name used for a key the organization has not renamed.  Only names an
// organization has set are stored, so these fill in for the rest.
export const DEFAULT_NAMES = {
  [DEPARTMENT_KEY]: "Department",
  [FACILITY_KEY]: "Facility",
}

// A custom name keeps the capitalization it was entered with, so that an acronym a
// client uses ("ED Unit") survives.  Copy that reads the name mid-sentence wants it
// lowercased, but lowercasing the whole string would destroy that acronym, so only
// words that look like ordinary capitalized English words are lowered.
const ORDINARY_CAPITALIZED_WORD = /^[A-Z][a-z]+$/

export const customNameInSentence = (name) => name
  .split(" ")
  .map((word) => (ORDINARY_CAPITALIZED_WORD.test(word) ? word.toLowerCase() : word))
  .join(" ")

// pluralize restores the case of the word it was given, so a name that is entirely an
// acronym comes back with an uppercase "s" ("ICU" becomes "ICUS").  Only the final word
// is ever inflected, so the "s" is appended directly when that word is an acronym.
const ALL_CAPS_WORD = /^[A-Z]+$/

export const pluralizeCustomName = (name) => {
  const words = name.split(" ")
  const lastWord = words[words.length - 1]

  if (!ALL_CAPS_WORD.test(lastWord)) return pluralize(name)

  return [...words.slice(0, -1), `${lastWord}s`].join(" ")
}

// The article depends on how the name is pronounced rather than how it is spelled
// ("a unit", "an hour", "a university campus", "an urban center"), which is what
// indefinite works out.  The name is lowered first so that an ordinary word is not
// mistaken for an initialism, while an acronym stays capitalized for it to pronounce.
export const customNameWithArticle = (name) => indefinite(customNameInSentence(name))

export const customNameForms = (name) => ({
  name,
  pluralName: pluralizeCustomName(name),
  nameInSentence: customNameInSentence(name),
  pluralNameInSentence: pluralizeCustomName(customNameInSentence(name)),
  nameWithArticle: customNameWithArticle(name),
})
